import { Button, Skeleton } from "antd"
import { useInvoicingSettingsQuery } from "../../../domain/invoicing/settings/invoicingSettingsQueries"
import VSpace from "../../common/VSpace"
import GeneralInvoicingSettingsCard from "./GeneralInvoicingSettingsCard"
import InvoiceReminderScheduleCard from "./InvoiceReminderScheduleCard"
import InvoicingSystemCard from "./InvoicingSystemCard"
import JobTypeSettingsCard from "./JobTypeSettingsCard"
import PaymentSummaryDefaultCard from "./PaymentSummaryDefaultCard"
import PassOnPaymentFeesCard from "./PassOnPaymentFeesCard"
import TaxRatesCard from "./TaxRatesCard"

type Props = {
  onEditEmailTemplates: () => void
}

const Settings = ({ onEditEmailTemplates }: Props) => {
  const invoicingSettingsQuery = useInvoicingSettingsQuery()

  return <>
    {invoicingSettingsQuery.isLoading && <Skeleton active />}
    {(invoicingSettingsQuery.data !== undefined) && <VSpace size="large">
      <InvoicingSystemCard invoicingSettings={invoicingSettingsQuery.data} />
      <PassOnPaymentFeesCard />
      <PaymentSummaryDefaultCard serverSettings={invoicingSettingsQuery.data} />
      <InvoiceReminderScheduleCard
        additionalActions={<Button onClick={onEditEmailTemplates}>Edit Templates</Button>}
      />
      <TaxRatesCard serverSettings={invoicingSettingsQuery.data} />
      <JobTypeSettingsCard serverSettings={invoicingSettingsQuery.data.defaultLineItemGrouping} />
      <GeneralInvoicingSettingsCard serverSettings={invoicingSettingsQuery.data} />
    </VSpace>}
  </>
}

export default Settings
